import { useMemo, useState } from 'react';
import throttle from 'lodash/throttle';
import useResizeObserver from 'use-resize-observer';

/**
 * Thanks to Viktor Hubert for this example
 * https://github.com/ZeeCoder/use-resize-observer#throttle--debounce
 */

const useThrottledResizeObserver = (wait, options) => {
    const [size, setSize] = useState({});
    const onResize = useMemo(() => throttle(setSize, wait), [wait]);
    const { ref } = useResizeObserver({ onResize, ...options });

    return { ref, ...size };
};

export default useThrottledResizeObserver;
